import { useEffect, Fragment } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// routes
// import { SnackbarProvider, useSnackbar } from 'notistack';
import Router from "./routes";
// components
import ScrollToTop from "./components/ScrollToTop";
import Navigator from "./components/Navigator";

// const onLine = navigator.onLine;
function App({ accessToken, user, component: Component, ...rest }, props) {
  const isOnline = Navigator();
  console.log(isOnline, "----navigator.onLine-11");

  return (
    <Fragment>
      <ScrollToTop />
      <Router />
    </Fragment>
  );
}

const mapStatetoProps = (state) => {
  console.log({ state });
  return {};
};

export default connect(mapStatetoProps)(App);
